export default __webpack_public_path__ + "static/media/no-notification.4f367f2b.svg";